/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 19:00 VN — WEB-20261015-suzitee-pdp-head-cluster
   Đã làm: nút "Show more / Show less" cho tiêu đề PDP mobile ((mọi viewport — desktop thêm 20:20 VN)). Đo ĐÚNG 1 LẦN sau (load hoặc 2.5s, cái nào tới trước — load có thể trễ vì app bên thứ 3) + fonts.ready (tối đa chờ thêm 1.5s): chỉ chèn nút khi tiêu đề thật sự bị cắt (line-clamp 2).
   Nút đặt tuyệt đối đè cuối dòng 2 (không thêm chiều cao => không CLS). Không observer, không timer lặp, không scroll/resize handler.
   AI Agent làm theo chỉ thị của anh Hoá — 2026-10-16 17:20 VN — WEB-20261016-suzitee-pdp-title-3lines (TITLE-v1)
   Đã làm: MOBILE (<=749px) — tiêu đề clamp 3 dòng (CSS), nút chỉ chèn khi scrollHeight > clientHeight (tức >3 dòng), nút nằm TRONG h1
   (float phải ở dòng 3, chữ nút lấy từ data-label qua CSS ::before nên textContent của h1 không đổi), mở => nút xuống cuối, "Show less".
   Đo lại khi fonts.ready xong muộn và khi ĐỔI CHIỀU RỘNG (resize/xoay màn hình, debounce 150ms; đổi chiều cao do thanh URL thì bỏ qua);
   giữ trạng thái mở khi đo lại.
   TITLE-v1.1 (2026-10-16 18:25 VN): mobile — nút ra NGOÀI h1, absolute góc phải dưới dòng 3 (Safari -webkit-box làm float thành hàng riêng => lỗi 2 dòng + nút nhảy lên đầu). DESKTOP (>=750px) giữ nguyên cách cũ: nút absolute đè cuối dòng 2, ngoài h1. Không observer, không timer lặp. */
(function () {
  'use strict';
  var mob = window.matchMedia('(max-width: 749px)');
  var block, h1, btn, lastW = -1, tmr = 0;
  function setMob(open) {
    var t = open ? 'Show less' : 'Show more';
    btn.setAttribute('data-label', t); btn.setAttribute('aria-label', t);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function build() {
    try {
      if (!block) {
        block = document.querySelector('.product__details--product-page .product-block--title');
        h1 = block && block.querySelector('.product_name');
      }
      if (!h1) return;
      lastW = window.innerWidth;
      var open = block.classList.contains('sz-pdp-head-open');
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
      btn = null;
      block.classList.remove('sz-pdp-head-open', 'sz-pdp-head-clamped');
      if (h1.scrollHeight <= h1.clientHeight + 1) return;
      btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'sz-pdp-head-more';
      if (mob.matches) {
        block.classList.add('sz-pdp-head-clamped');
        var lh = parseFloat(getComputedStyle(h1).lineHeight) || 23;
        var mtop = h1.offsetTop + h1.clientHeight - lh;
        setMob(open);
        if (open) block.classList.add('sz-pdp-head-open');
        btn.style.top = mtop + 'px';
        h1.insertAdjacentElement('afterend', btn);
        btn.addEventListener('click', function () {
          var o = block.classList.toggle('sz-pdp-head-open');
          setMob(o);
        });
      } else {
        var lh = parseFloat(getComputedStyle(h1).lineHeight) || 23;
        var top = h1.offsetTop + h1.clientHeight - lh;
        btn.textContent = open ? 'Show less' : 'Show more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false'); btn.style.top = open ? '' : top + 'px';
        if (open) block.classList.add('sz-pdp-head-open');
        var b = btn;
        b.addEventListener('click', function () {
          var o = block.classList.toggle('sz-pdp-head-open');
          b.textContent = o ? 'Show less' : 'Show more';
          b.setAttribute('aria-expanded', o ? 'true' : 'false');
          b.style.top = o ? '' : top + 'px';
        });
        block.appendChild(btn);
      }
    } catch (e) {}
  }
  var done = false;
  function go() {
    if (done) return; done = true;
    try {
      var fr = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      Promise.race([fr, new Promise(function (r) { setTimeout(r, 1500); })]).then(build, build);
      fr.then(function () { if (lastW !== -1) build(); }, function () {});
    } catch (e) { build(); }
    window.addEventListener('resize', function () {
      clearTimeout(tmr);
      tmr = setTimeout(function () { if (window.innerWidth !== lastW) build(); }, 150);
    }, { passive: true });
  }
  if (document.readyState === 'complete') go();
  else { window.addEventListener('load', go, { once: true }); setTimeout(go, 2500); }
})();
